// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/storico-prezzi?societaId={id}&q={q}&fornitoreId={id}&dal={data}&al={data}&soloVariazioni={bool}&page={n}&limit={n}',
    requestBody: null,
    response: '{"success":true,"data":[{"rigaId":"number","codiceArticolo":"string","descrizioneBase":"string","prezzoStandard":"string","prezzoPrecedente":"string|null","prezzoAttuale":"string|null","umAcquisto":"string|null","importId":"number","etichetta":"string","importatoAt":"string","utenteName":"string","fornitoreId":"number|null","fornitoreRagioneSociale":"string|null","articoloId":"number|null"}],"total":"number","page":"number","limit":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/storico-prezzi/fornitori?societaId={id}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","ragioneSociale":"string|null","nome":"string|null"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
